import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { Container, Grid2, FormControlLabel, Switch, } from '@mui/material'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination'
import Loading from '../../../BuiltInComponent/Loading'
import { branchList } from '../../../features/AdminManagement/branchSlice'
import { useState } from 'react'

export default function BranchListing() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { masterData, isLoading } = useSelector((state) => state.branches)
    const [branchStatus, setBranchStatus] = useState(true)
    React.useEffect(() => {
        dispatch(branchList({ getOrder: true }))
        // dispatch(getPurchaseDetailData('blank'))
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'branchID', cName: 'Invoice No', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'branchID', cName: 'Branch ID', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'branchName', cName: 'Branch Name', textAlign: 'left', width: 150, status: 'en', dType: 'string' },
        { fieldName: 'branchAddress', cName: 'Address', textAlign: 'left', width: 300, status: 'en', dType: 'string' },
        { fieldName: 'branchContactNo', cName: 'Contact No', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'branchCategory', cName: 'Caetgory', textAlign: 'left', width: 100, status: 'en', dType: 'string' },
        { fieldName: 'branchStatus', cName: 'Current Status', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
    ];

    const onEditClick = async (itemCode) => {
        console.log(itemCode)
        navigate('/AddBranch', { state: { branchID: itemCode } })
    }
    const onDeleteClick = async (itemCode) => { }

    const onAddNewClick = () => {

        navigate('/AddBranch')

    }

    return (
        <>
            <Navbar />
            <Container>
                <Grid2 container spacing={2} sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid2 size={9}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={branchStatus}
                                    onChange={(e) => {
                                        setBranchStatus(e.target.checked)
                                        dispatch(branchList({ getOrder: e.target.checked }))
                                    }
                                    }
                                    name="branchStatus"
                                />
                            }
                            label={branchStatus ? "Active Branches" : "InActive Branches"}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <ButtonNormal text='Add New Branch' onClick={onAddNewClick} />
                    </Grid2>
                    <Grid2 size={9}>
                    </Grid2>
                    <Grid2 size={3}>
                    </Grid2>
                </Grid2>
                {isLoading ? <Loading /> :
                    <StickyHeadTable tableColumns={tableColumns} tableData={masterData && masterData}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} />
                }

            </Container>
        </>
    )
}